function initFreshChat() {
try {
    window.fcWidget.init({
    token: "6615bfd5-460c-4244-be5d-63b818283059",
    host: "https://fashionsociety2.freshchat.com",
    tags: ["pointcarre"]
    });
} catch (error) {
    console.warn('FreshChat initialization failed:', error);
}
}
function initialize(i,t){
var e;
if(i.getElementById(t)) {
    initFreshChat();
} else {
    try {
    e = i.createElement("script");
    e.id = t;
    e.async = true;
    e.src = "https://fashionsociety2.freshchat.com/js/widget.js";
    e.onload = initFreshChat;
    e.onerror = function() {
        console.warn('FreshChat script failed to load - this may be due to ad blockers or network issues');
    };
    i.head.appendChild(e);
    } catch (error) {
    console.warn('FreshChat script creation failed:', error);
    }
}
}
function initiateCall(){
try {
    initialize(document,"Freshchat-js-sdk");
} catch (error) {
    console.warn('FreshChat initialization failed:', error);
}
}
if (window.addEventListener) {
window.addEventListener("load", initiateCall, false);
} else {
window.attachEvent("load", initiateCall, false);
}